import { type TypedUseSelectorHook, useSelector } from 'react-redux';

import { type store } from './store';

export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
